export default "__VITE_ASSET__Bn$u_4SE__"